export enum ChatMessageType {
  model = 'Model',
  hero = 'Hero',
  jumpToChat = 'JumpToChat',
  offline = 'Offline',
  advertisement = 'Advertisement'
}
